export const CompatibilityGuidelinesConstant = {
    API: 'CompatibilityGuidlines'
}

export const CompatibilityGuidelinesAPIConstant = {
    COMPATIBILITYGUIDLINES: 'CompatibilityGuidlines',
    COMPATIBILITYGUIDLINES_CREATE: 'CompatibilityGuidlines/Create',
    MARKCOMPATIBILITYGUIDEFILEDOWNLOADED: 'CompatibilityGuidlines/MarkCompatibilityGuideFileDownloaded',
    GETLASTUPLOADED: 'CompatibilityGuidlines/GetLastUploaded'
}